import cn from 'classnames';
import { format } from 'date-fns';
import React from 'react';

import { Text } from '@sravni/react-design-system/lib/Typography';

import { useIsGoogleSearch } from '@src/reducers/metadata';

import styles from './styles.module.scss';

const REGION_REGEX = [/{город.где}/, /{город.родительный}/];

interface ILocationHeaderProps {
  className?: string;
  header: string;
  size?: 'normal' | 'inherit';
  position?: 'left' | 'center';
}

export const PageLocationHeader: React.FC<ILocationHeaderProps> = ({ header, className }) => {
  let heading: string | string[] = header;
  const isUserFromGoogleSearch = useIsGoogleSearch();

  const regionRegexIndex = REGION_REGEX.find((item) => item.test(header));

  if (regionRegexIndex) {
    heading = header.split(regionRegexIndex);
  }

  const [regionHeading, regionSubheading] = heading;

  return (
    <div className={cn(styles.page_location, className)}>
      <h1>
        {regionRegexIndex ? (
          <>
            <span>{regionHeading}</span>
            {regionSubheading ? <span>{regionSubheading}</span> : null}
          </>
        ) : (
          heading
        )}
      </h1>
      {isUserFromGoogleSearch && <Text className="h-color-D60">Обновлено: {format(new Date(), 'dd.MM.yyyy')}</Text>}
    </div>
  );
};
